import {useSettingsQuery} from '../../../common/providers'
import {useUrlParam} from '../../../routing'

export const useConstraintsQuery = (plantCode?: string) => {
  const urlPlantCode = useUrlParam('plantCode')

  return useSettingsQuery('constraints', [plantCode ?? urlPlantCode])
}
